// extracted by mini-css-extract-plugin
export default {"PasswordInput":"AccountAndPwdForm_PasswordInput__Arz+2","ForgotPwd":"AccountAndPwdForm_ForgotPwd__4bbzD"};